export const REPORT_SCOPES = {
  people: {
    label: "People Reports",
    typeLabel: "All People Reports",
    path: "/people/reports",
    reportTypeKeys: [
      "employeeMaster",
      "organizationManagement",
      "eoeManagement",
      "assessmentManagement",
      "transferPromotion",
      "recruitment",
    ],
  },
  time: {
    label: "Time Reports",
    typeLabel: "All Time Reports",
    path: "/time/reports",
    reportTypeKeys: [
      "attendanceManagement",
      "leaveManagement",
      "rosterManagement",
    ],
  },
  payroll: {
    label: "Payroll Reports",
    typeLabel: "All Payroll Reports",
    path: "/payroll/reports",
    reportTypeKeys: [
      "payrollManagement",
      "expenseManagement",
      "lendManagement",
      "travelManagement",
    ],
  },
  admin: {
    label: "Admin Reports",
    typeLabel: "All Admin Reports",
    path: "/admin/reports",
    reportTypeKeys: ["masters"],
  },
};

export const REPORT_SCOPE_KEYS = Object.keys(REPORT_SCOPES);

export const getReportScope = (scope) => REPORT_SCOPES[scope] || null;

export const getReportListPath = (scope) => getReportScope(scope)?.path || "/reports/all-reports";

export const getReportTypeKeysForScope = (scope) => getReportScope(scope)?.reportTypeKeys || [];
